import React, {useEffect, useState} from "react";
import {FIREBASE_SCREEN_NAMES, LOCALSTORAGE_ITEMS} from "../../util/Constants";
import * as StorageService from "../../services/StorageService";
import {FormattedMessage} from "react-intl";
import backImg from "../../assets/img/icon_back.svg";
import 'react-calendar/dist/Calendar.css';
import * as ReservationService from "../../services/ReservationService";
import {resetTime} from "../../util/common";
import {DATE_FORMAT} from "../../util/DateUtil";
import Moment from "react-moment";
import iconLocation from "../../assets/img/icon_location.svg";
import iconPhone from "../../assets/img/icon_phone.svg";
import {PATH} from "../../routes/routes.js";
import {EventBus} from "../../util/EventBus";
import analyticsLogEvent from "../../services/FirebaseService";
import CookiesBanner from "../../components/Banner/CookiesBanner";
import {useNavigate} from "react-router";
import {useParams} from "react-router-dom";

function ReservationDetails(props) {

    const {rid} = useParams();
    const navigateTo = useNavigate();
    const today = new Date();
    const tomorrow = resetTime(new Date());
    tomorrow.setDate(tomorrow.getDate() + 1);

    const visible = "visible";
    const hidden = "hidden";

    const [state, setState] = useState({
        loading: false,
        errorMsg: null,
        reservationDetails: {},
        shopDetails: null,
        currentStyle:hidden
    });

    useEffect(() => {
        getPageContent().then(r=>{
            analyticsLogEvent("screen_view", {
                firebase_screen: FIREBASE_SCREEN_NAMES.RESERVATION_DETAILS,
                firebase_screen_class: FIREBASE_SCREEN_NAMES.RESERVATION_DETAILS
            });
        });
    }, []);

    const getPageContent = async () => {
        if (StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)) {
            await getReservation().then(response => {
                setState({
                    ...state,
                    shopDetails: JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)),
                    reservationDetails: response.data
                })
            });
        } else {
            return;
        }
    }


    const getReservation = async () => {
        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "rid": rid
        }
        const response = await ReservationService.getReservation(body);
        if (response.ok) {
            console.log("getReservation: ", response.data);
        } else {
            EventBus.dispatch("genericErrorMsg");
            console.log("Error retrieving reservation");

        }
        return response;
    }

    const cancelReservation = async () => {
        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "rid": rid
        }

        const response = await ReservationService.cancelReservation(body);
        if (response.ok) {
            navigateTo(PATH.ALL_RESERVATIONS);
        } else {
            EventBus.dispatch("genericErrorMsg");
            console.log("Error: couldn't cancel reservation");
        }
        return response.data;
    }

    const goBack = () => {
        navigateTo(PATH.ALL_RESERVATIONS);
    }

    const openModal = () => {
        setState({
            ...state,
            currentStyle: visible
        })
    }
    const closeModal = () => {
        setState({
            ...state,
            currentStyle: hidden
        })
    }

    const reservationIsClosed = (reservationDetails) => {
        if (reservationDetails.procStatus === "CANCELED" || reservationDetails.procStatus === "DECLINED") {
            return true;
        } else {
            return false;
        }
    }


    const getReservationTopBannerStatusText = (reservationDetails) => {
        switch (reservationDetails.procStatus) {
            case "CANCELED":
                return <FormattedMessage id="ReservationRequestCanceled"/>
            case "DECLINED":
                return <FormattedMessage id="ReservationRequestDeclined"/>
            case "NEW":
                return <FormattedMessage id="ReservationRequestNew"/>;
            case "CONFIRMED":
                return  <FormattedMessage id="ReservationRequestConfirmed"/>
            case "ARRIVED":
                return <FormattedMessage id="ReservationRequestArrived"/>
            default:
                return <FormattedMessage id="ReservationRequestNew"/>;
        }
    }
    const getTodayOrTomorrowStringFromDate = (obj) => {
        var miliseconsPassedFrom70 = Date.parse(obj.date);
        var dateObj = new Date();
        dateObj.setTime(miliseconsPassedFrom70);

        if (resetTime(today).getTime() === resetTime(dateObj).getTime()) {
            return <FormattedMessage id="Today"/>;
        } else if (resetTime(tomorrow).getTime() === resetTime(dateObj).getTime()) {
            return <FormattedMessage id="Tomorrow"/>;
        } else {
            return <Moment
                format={DATE_FORMAT.DAY_MONTH_YEAR_MOBILE_VERSION}
                date={dateObj}
            />
        }
    }



    return (
        <> <CookiesBanner/>
        <div className="reservation-details">
            {state.shopDetails?.merchantConfig && state.reservationDetails &&
            <div className="inner-content">

                <div data-qa="modal-overlay" className={state.currentStyle+" modal-overlay "} onClick={(e)=> closeModal()}>   </div>
                <div className="modal">
                    <div className="row">
                        <div className="modal-title"><FormattedMessage id="AreYouSureYouWantToCancelReservation"/></div>
                    </div>

                    <div className="row">
                        <a data-qa="res-details-modal-close-modal-btn" className=" btn btn-outlined btn-md" onClick={closeModal}><FormattedMessage id="No"/></a>
                        <a data-qa="res-details-modal-cancel-res-btn" className=" btn btn-outlined btn-md" onClick={cancelReservation}><FormattedMessage id="Yes"/></a>
                    </div>
                </div>

                <header className="common-header no-bg">
                    <a className="btn-back" onClick={goBack}><img alt="back button icon"  src={backImg}/></a>
                    <div className={"row status-banner" + " " + state.reservationDetails?.procStatus?.toLowerCase()}>
                        {getReservationTopBannerStatusText(state.reservationDetails)}
                        {state.reservationDetails.message && <p>{ state.reservationDetails.message }</p>}
                    </div>
                    {state.shopDetails?.title && <h2 className="row title">{state.shopDetails?.title}</h2>}
                    {state.shopDetails?.data.address &&
                    <div className="row address"><img alt="location icon" src={iconLocation}/>{state.shopDetails?.data.address}
                    </div>}
                    {state.shopDetails?.data.phone &&
                    <div className="row phone"><img alt="phone icon" src={iconPhone}/>{state.shopDetails?.data.phone}</div>}
                </header>

                <section className="reservation-information">

                    <div className="reservation-details-group">
                        <div className="row">
                            <h3 className="subtitle"><FormattedMessage id="ReservationDetails"/></h3>
                        </div>
                        <div className="row">
                            <div className="col">
                                {getTodayOrTomorrowStringFromDate(state.reservationDetails)}&nbsp;&nbsp;&nbsp;
                            </div>
                            <div className="col">
                                <Moment
                                    format={DATE_FORMAT.HOUR_MINUTES}
                                    date={state.reservationDetails.date}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                {state.reservationDetails.guestsNr}&nbsp;<FormattedMessage id="People"/>
                            </div>
                        </div>

                        {state.reservationDetails.request != null && state.reservationDetails.request !== "" ?
                            <div className="row">
                                <div className="col">
                                    <FormattedMessage id="OtherRequests"/>&#58;&nbsp;{state.reservationDetails.request}
                                </div>
                            </div>
                            : null
                        }
                    </div>

                    <div className="reservation-contact-group">


                        <div className="row">
                            <h3 className="subtitle"><FormattedMessage id="ReservationContact"/></h3>
                        </div>
                        <div className="row">
                            {state.reservationDetails.name} &nbsp; {state.reservationDetails.contact}
                        </div>
                    </div>
                </section>
                {!reservationIsClosed(state.reservationDetails) ?
                    <section>
                        <div className="row reservation-cancelation">
                            <p><FormattedMessage id="IfYouChangeYourMind"/>&nbsp;
                                <button data-qa="res-details-open-cancel-res-modal" onClick={()=> openModal()} className="btn btn-link btn-danger">
                                    <FormattedMessage
                                        id="CancelYourReservation"/></button>
                            </p>
                        </div>
                    </section>
                    : null
                }
            </div>
            }
        </div>
        </>
    );
}

export default ReservationDetails;
